enum DashboardConstants {
  GET_INCOME_SUMMARY_REQUEST = "GET_INCOME_SUMMARY_REQUEST",
  GET_INCOME_SUMMARY_SUCCESS = "GET_INCOME_SUMMARY_SUCCESS",
  GET_INCOME_SUMMARY_FAILURE = "GET_INCOME_SUMMARY_FAILURE",

  GET_CLIENT_TYPE_INCOME_REQUEST = "GET_CLIENT_TYPE_INCOME_REQUEST",
  GET_CLIENT_TYPE_INCOME_SUCCESS = "GET_CLIENT_TYPE_INCOME_SUCCESS",
  GET_CLIENT_TYPE_INCOME_FAILURE = "GET_CLIENT_TYPE_INCOME_FAILURE",

  GET_INCOME_CHART_DATA_REQUEST = "GET_INCOME_CHART_DATA_REQUEST",
  GET_INCOME_CHART_DATA_SUCCESS = "GET_INCOME_CHART_DATA_SUCCESS",
  GET_INCOME_CHART_DATA_FAILURE = "GET_INCOME_CHART_DATA_FAILURE",

  GET_PAYMENT_CHART_DATA_REQUEST = "GET_PAYMENT_CHART_DATA_REQUEST",
  GET_PAYMENT_CHART_DATA_SUCCESS = "GET_PAYMENT_CHART_DATA_SUCCESS",
  GET_PAYMENT_CHART_DATA_FAILURE = "GET_PAYMENT_CHART_DATA_FAILURE",

  GET_TOP_EARNING_ACCOUNT_REQUEST = "GET_TOP_EARNING_ACCOUNT_REQUEST",
  GET_TOP_EARNING_ACCOUNT_SUCCESS = "GET_TOP_EARNING_ACCOUNT_SUCCESS",
  GET_TOP_EARNING_ACCOUNT_FAILURE = "GET_TOP_EARNING_ACCOUNT_FAILURE",

  GET_TOP_EARNING_PLATFORM_REQUEST = "GET_TOP_EARNING_PLATFORM_REQUEST",
  GET_TOP_EARNING_PLATFORM_SUCCESS = "GET_TOP_EARNING_PLATFORM_SUCCESS",
  GET_TOP_EARNING_PLATFORM_FAILURE = "GET_TOP_EARNING_PLATFORM_FAILURE",
}

export default DashboardConstants;
